import { useEffect } from "react";
import Navigation from "@/components/sections/Navigation";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Funnel from "@/components/sections/Funnel";
import AboutMe from "@/components/sections/AboutMe";
// import WorkoutTimeline from "@/components/sections/WorkoutTimeline";
import FAQ from "@/components/sections/FAQ";

import Footer from "@/components/sections/Footer";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Button } from "@/components/ui/button";

const Index = () => {
  useScrollReveal();

  useEffect(() => {
    // Smooth scrolling for anchor links
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <main>
        <div id="home">
          <Hero />
        </div>
        <Funnel />
        <About />
        <AboutMe />
        {/* <WorkoutTimeline /> */}
        <FAQ />
        
        
      </main>
      <Footer />
    </div>
  );
};

export default Index;
